import { z } from "zod";

export const loginSchema = z.object({
  username: z.string().trim().min(1),
  password: z.string().trim().min(1),
});

export const registerSchema = z
  .object({
    name: z
      .string()
      .min(3, "El nombre debe tener al menos 3 caracteres.")
      .max(60),
    username: z
      .string()
      .min(3, "El nombre de usuario debe tener al menos 3 caracteres.")
      .max(40),
    email: z.string().email("El  correo no es válido."),
    password: z
      .string()
      .min(6, "La contraseña debe tener al menos 6 caracteres.")
      .max(60),
    password2: z.string(),
  })
  .refine((data) => data.password === data.password2, {
    message: "Las contraseñas no coinciden.",
    path: ["password2"],
  });

export const recoverSchema = z.object({
  email: z.string().email("Debe ser un correo válido."),
});

export const changePasswordSchema = z
  .object({
    password: z
      .string()
      .min(8, "La contraseña debe tener al menos 8 caracteres."),
    password2: z.string(),
  })
  .refine((data) => data.password === data.password2, {
    message: "Las contraseñas no coinciden.",
    path: ["password2"],
  });

export const invitedUserSchema = z
  .object({
    name: z
      .string()
      .min(3, "El nombre debe tener al menos 3 caracteres.")
      .max(60),
    username: z
      .string()
      .min(3, "El nombre de usuario debe tener al menos 3 caracteres.")
      .max(40),
    email: z.string().email("El  correo no es válido."),
    password: z
      .string()
      .min(6, "La contraseña debe tener al menos 6 caracteres.")
      .max(60),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Las contraseñas no coinciden.",
    path: ["confirmPassword"],
  });

export const validateLoginSchema = (data) => loginSchema.safeParse(data);

export const validateRegisterSchema = (data) => registerSchema.safeParse(data);
